import { PublicInvoice } from 'pages/Invoices/PublicInvoice';
import { RouteObject } from 'react-router-dom';

const publicInvoiceRoute = (): RouteObject => ({
  path: 'public-invoice/:id',
  element: <PublicInvoice />,
});

export default publicInvoiceRoute;
